import { Icon } from '@arcadiapower/shrike';
import { useState } from 'react';
import type { Utility } from 'typings/context';
import { ImageSelector, type ImageType } from '~/components/image';
import { Container, type ContainerProps } from '~/components/layout';
import { Text } from '~/components/typography';

export const Expander = ({
  utility,
  info: { title, type },
  ...containerProps
}: { utility: Utility; info: { title: string; type: ImageType } } & ContainerProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleIsOpen = () => setIsOpen(isOpen => !isOpen);

  return (
    <Container {...containerProps}>
      <Container
        role="button"
        aria-pressed={isOpen}
        tabIndex={0}
        onClick={toggleIsOpen}
        onKeyDown={toggleIsOpen}
        style={{ cursor: 'pointer' }}
        display="flex"
        pr={2}
        mb={2}
      >
        <Icon icon="InfoCircleInverted" scale={2} margin={{ right: '8px', top: '4px' }} />
        <Text textStyle="paragraph500">{title}</Text>
        <Icon
          margin={{ top: '4px' }}
          icon={isOpen ? 'ChevronUp' : 'ChevronDown'}
          title={`Example ${utility.displayName} bill`}
        />
      </Container>
      {isOpen ? <ImageSelector type={type} /> : null}
    </Container>
  );
};
